import { format } from "date-fns";

const Filter = ({
  setFilter,
  filter,
  fetch,
  onClick,
  onChange,
  provincias,
  categorias,
  setData,
  salas,
  setSalas,
}) => {
  return (
    <div className="row py-3">
      <div className="col-md-3 mb-3">
        <div className="d-flex">
          <input
            className="form-control border border-dark py-1"
            style={{ borderRadius: "10px 0px 0px 10px" }}
            type="search"
            name="search"
            placeholder="Buscar"
            onChange={(e) => onChange(e)}
          />
          <label
            className="btn btn-dark border-0 me-2 py-1"
            style={{ borderRadius: "0px 10px 10px 0px" }}
          >
            <i className="bi bi-search"></i>
            <button
              className="d-none"
              name="search"
              onClick={(e) => onClick(e)}
            ></button>
          </label>
        </div>
      </div>
      <div className="col-md-3 mb-3">
        <select
          class="form-select"
          aria-label="Default select example"
          onChange={(e) => {
            if (e.target.value == "todos") {
              let params = filter;
              delete params["filter[provincia]"];
              setFilter({ ...params });
              return fetch(setData, params, "/eventos");
            }

            setFilter({ ...filter, ["filter[provincia]"]: e.target.value });
            let params = { ...filter, ["filter[provincia]"]: e.target.value };

            fetch(setData, params, "/eventos");
            fetch(
              setSalas,
              { ["filter[provincia]"]: e.target.value },
              "/salas"
            );
          }}
        >
          <option selected>Seleccionar provincia</option>
          <option value={"todos"}>Todos</option>
          {provincias.map((provincia) => {
            return (
              <option
                value={provincia.provincia}
              >{`${provincia.provincia} (${provincia.total_eventos})`}</option>
            );
          })}
        </select>
      </div>
      <div className="col-md-3 mb-3">
        <select
          class="form-select"
          aria-label="Default select example"
          onChange={(e) => {
            if (e.target.value == "todos") {
              let params = filter;
              delete params["filter[nombre_sitio]"];
              setFilter({ ...params });
              return fetch(setData, params, "/eventos");
            }

            setFilter({ ...filter, ["filter[nombre_sitio]"]: e.target.value });
            let params = {
              ...filter,
              ["filter[nombre_sitio]"]: e.target.value,
            };

            fetch(setData, params, "/eventos");
          }}
        >
          <option selected>Seleccionar sala</option>
          <option value={"todos"}>Todos</option>
          {salas.data.map((sala) => {
            return <option value={sala.nombre}>{`${sala.nombre}`}</option>;
          })}
        </select>
      </div>
      <div className="col-md-3 mb-3">
        <select
          class="form-select"
          aria-label="Default select example"
          onChange={(e) => {
            if (e.target.value == "todos") {
              let params = filter;
              delete params["filter[category]"];
              setFilter({ ...params });
              return fetch(setData, params, "/eventos");
            }
            setFilter({ ...filter, ["filter[category]"]: e.target.value });
            let params = { ...filter, ["filter[category]"]: e.target.value };
            fetch(setData, params, "/eventos");
          }}
        >
          <option selected>Seleccionar categoria</option>
          <option value={"todos"}>Todos</option>
          {categorias.map((categoria) => {
            return <option value={categoria.id}>{categoria.nombre}</option>;
          })}
        </select>
      </div>
      <div className="col-md-3 mb-3">
        <select
          class="form-select"
          aria-label="Default select example"
          onChange={(e) => {
            if (e.target.value == "todos") {
              let params = filter;
              delete params["status"];
              setFilter({ ...params });
              return fetch(setData, params, "/eventos");
            }
            setFilter({ ...filter, status: e.target.value });
            let params = { ...filter, status: e.target.value };
            fetch(setData, params, "/eventos");
          }}
        >
          <option selected>Seleccionar estado</option>
          <option value="todos">Todos</option>
          <option value="1">Activo</option>
          <option value="2">Pausado</option>
          <option value="3">Eliminado</option>
          <option value="4">Borrador</option>
        </select>
      </div>
      <div className="col-md-3 mb-3">
        <div className="d-md-flex align-items-center">
          <span className="text-muted me-1" style={{ fontSize: "12px" }}>
            Desde
          </span>
          <input
            type="date"
            class="form-control d-flex mx-2"
            onChange={(e) => {
              let hasta = filter.hasOwnProperty("filter[fecha]")
                ? filter["filter[fecha]"].split(",")[1]
                : format(new Date(), "yyyy-M-dd").toString();

              let params = {
                ...filter,
                ["filter[fecha]"]: `${e.target.value},${hasta}`,
              };

              setFilter({ ...params });
              return fetch(setData, params, "/eventos");
            }}
          />
          <span className="text-muted me-1" style={{ fontSize: "12px" }}>
            Hasta
          </span>
          <input
            type="date"
            class="form-control d-flex  mx-2"
            onChange={(e) => {
              let desde = filter.hasOwnProperty("filter[fecha]")
                ? filter["filter[fecha]"].split(",")[0]
                : format(new Date(), "yyyy-M-dd").toString();

              let params = {
                ...filter,
                ["filter[fecha]"]: `${desde},${e.target.value}`,
              };

              setFilter({ ...params });
              return fetch(setData, params, "/eventos");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Filter;
